import React from 'react'
import { Text, CheckboxField } from '@adc/ui-core'
import ValueChangedAlert from '../valueChangedAlert'

type TraditionalOfferActionFooterProps = {
  disclaimerAcknowledged: boolean
  setDisclaimerAcknowledged: (checked: boolean) => void
  isLoading: boolean
  bidAmount: number
  loadingText: string
  acknowledgeText: string
  alertText: string
}
const TraditionalOfferActionFooter = ({
  disclaimerAcknowledged,
  setDisclaimerAcknowledged,
  isLoading,
  bidAmount,
  loadingText,
  acknowledgeText,
  alertText,
}: TraditionalOfferActionFooterProps) => {
  return (
    <>
      <Text className='u-mb-2' size='tiny' color='gray'>
        <CheckboxField
          checked={disclaimerAcknowledged}
          onChange={() => setDisclaimerAcknowledged(!disclaimerAcknowledged)}
          elmId='bid_acknowledgement_checkbox'
          label={acknowledgeText}
        />
      </Text>

      {isLoading && <p className='u-mb-2 u-mt-1'>{loadingText}</p>}
      <ValueChangedAlert text={alertText} value={bidAmount} />
    </>
  )
}

export default TraditionalOfferActionFooter
